export default "__VITE_ASSET__4c624f3c__"